
  const isMobile = window.innerWidth <= 768;
  const marqueeSpeed = isMobile ? 2000 : 4000;

  new Swiper('.marquee-swiper-wrapper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    speed: marqueeSpeed,
    allowTouchMove: false,
    lazy: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    loop: true
  });
